<!--
 sorry for the duplicated code, but I didn't find a better way:
 * angular does not support conditional use of directives, and if the routerLink is present it overwrite the href even if the link is undefined, "" or []
 * routerLink must be applied directly on an <a> tag to render a href, so we can't externalize the visual part into a separate component
-->

<a *ngIf="href && !deactivated" [href]="href" [attr.target]="target" [ngClass]="classes"
   [title]="tooltipKey ? (tooltipKey | translate) : ''"
   (click)="click()" class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
  <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
  </ng-template>
</a>

<a *ngIf="url && !deactivated && !children" routerLink="{{url}}" [queryParams]="queryParameter" [target]="target" [ngClass]="classes"
   [title]="tooltipKey ? (tooltipKey | translate) : ''"
   (click)="click()" class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
  <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
  </ng-template>
</a>

<a *ngIf="url && !deactivated && children"  [target]="target" [ngClass]="classes"
  [title]="tooltipKey ? (tooltipKey | translate) : ''"
  (click)="click()" class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
  <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
  </ng-template>
</a>

<!-- Difference to Stack @TODO After BAG 51 -->

<a *ngIf="deactivated" [target]="target" [ngClass]="classes" [title]="tooltipKey ? (tooltipKey | translate) : ''"
   class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
  <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
  </ng-template>
</a>

<ng-template #item>
  <span *ngIf="icon" class="fas {{icon}} fa-fw text-primary" aria-hidden="true"></span>
  <span [class.ml-2]="icon">{{labelKey | translate}}</span>
  <i class="fas fa-chevron-right fa-fw" aria-hidden="true" *ngIf="children"></i>
</ng-template>

<div class="heading-children" [ngClass]="classes" *ngIf="children">
  <ng-content></ng-content>
</div>
